/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { Channel } from '../../common/types/types';

interface InvokeChannelJobMutationProps {
    channel: Channel;
    jobName: string;
}

export default class InvokeChannelJobMutation extends Relay.Mutation<InvokeChannelJobMutationProps> {

    static propTypes = {
        channel: PropTypes.object.isRequired,
        jobName: PropTypes.string.isRequired,
    };

    static fragments = {
        channel: () => Relay.QL`
              fragment on Channel {
                    organisation_id,
                    id,
              }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {invokeChannelJob}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on InvokeChannelJobPayload {
                job {
                    id,
                    organisation_id,
                    realId,
                    name
                }
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel.id,
            organisation_id: this.props.channel.organisation_id,
            jobName: this.props.jobName,
        };
    }
}

export function channelJobMutationPromise(params) {
	return new Promise((resolve, reject) => {
		let onFailure = (transaction) => { reject(transaction); };
		let onSuccess = (response) => { resolve(response); };

		Relay.Store.commitUpdate(new InvokeChannelJobMutation(params), {
			onFailure,
			onSuccess
		});
	});
}
